export const environment = {
  production: true,
  buildId: '4036265146424491',
  configFile: 'config.json',
};
